import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/v_logo.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-137d93bc")

_pushScopeId("data-v-137d93bc")
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
const _hoisted_3 = { class: "nativesStats" }
const _hoisted_4 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "logo"
    }, {
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_3, [
      (_ctx.store.state.assetCount)
        ? (_openBlock(), _createBlock("div", _hoisted_4, " Assets: " + _toDisplayString(_ctx.store.state.assetCount), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
})